const TOKEN_KEY = "seilan_token";

export function getToken(): string | null {
  const raw = localStorage.getItem(TOKEN_KEY);
  if (raw) return raw;
  // The legacy backend also drops the JWT into a cookie on email-verification
  // redirect. Honor that as a fallback so users land on /dashboard cleanly.
  const m = document.cookie.match(/seilan_token=([^;]+)/);
  return m ? m[1] : null;
}

export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  localStorage.removeItem(TOKEN_KEY);
  document.cookie = "seilan_token=;path=/;max-age=0";
}
